var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 53,
    viewBox: "0 0 181 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.812 52.0355H7.3743C3.71434 52.0355 0.716797 49.1089 0.716797 45.5355V6.53553C0.716797 2.96215 3.71434 0.0355252 7.3743 0.0355252H173.812C177.472 0.0355252 180.469 2.96215 180.469 6.53553V45.5355C180.469 49.1089 177.472 52.0355 173.812 52.0355Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.812 1.07715C176.894 1.07715 179.403 3.52602 179.403 6.53553V45.5355C179.403 48.545 176.894 50.9939 173.812 50.9939H7.3743C4.29188 50.9939 1.78366 48.545 1.78366 45.5355V6.53553C1.78366 3.52602 4.29188 1.07715 7.3743 1.07715H173.812ZM173.812 0.0355252H7.3743C3.71434 0.0355252 0.716797 2.96215 0.716797 6.53553V45.5355C0.716797 49.1089 3.71434 52.0355 7.3743 52.0355H173.812C177.472 52.0355 180.469 49.1089 180.469 45.5355V6.53553C180.469 2.96215 177.472 0.0355252 173.812 0.0355252Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8534 13.3524C63.8534 14.4379 63.5205 15.3073 62.8647 15.9556C62.1108 16.7243 61.1288 17.111 59.9255 17.111C58.7754 17.111 57.7934 16.7178 56.9878 15.9426C56.1806 15.1561 55.7778 14.1909 55.7778 13.0355C55.7778 11.8801 56.1806 10.9149 56.9878 10.1349C57.7934 9.35327 58.7754 8.96002 59.9255 8.96002C60.498 8.96002 61.0439 9.0754 61.5649 9.2899C62.0841 9.50602 62.5069 9.79852 62.8131 10.1593L62.1174 10.845C61.5832 10.2291 60.8558 9.92527 59.9255 9.92527C59.0866 9.92527 58.3593 10.2113 57.7418 10.7881C57.131 11.3666 56.8247 12.1158 56.8247 13.0355C56.8247 13.9553 57.131 14.7109 57.7418 15.2894C58.3593 15.8598 59.0866 16.1523 59.9255 16.1523C60.8159 16.1523 61.5649 15.8598 62.1557 15.2829C62.5452 14.901 62.7665 14.3745 62.8248 13.7018H59.9255V12.7625H63.7935C63.8401 12.9656 63.8534 13.1623 63.8534 13.3524Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9896 10.0959H66.3562V12.5659H69.6317V13.5051H66.3562V15.9751H69.9896V16.9323H65.3276V9.13876H69.9896V10.0959Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3207 16.9323H73.2921V10.0959H71.0635V9.13876H76.5509V10.0959H74.3207V16.9323Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.522 16.9323V9.13876H81.5489V16.9323H80.522Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1009 16.9323H85.0807V10.0959H82.8438V9.13876H88.3378V10.0959H86.1009V16.9323Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7267 15.9296C97.9395 16.7178 96.9641 17.111 95.8007 17.111C94.6307 17.111 93.6554 16.7178 92.8681 15.9296C92.0825 15.1431 91.6914 14.1779 91.6914 13.0355C91.6914 11.8931 92.0825 10.9279 92.8681 10.1414C93.6554 9.35327 94.6307 8.96002 95.8007 8.96002C96.9575 8.96002 97.9328 9.35327 98.7201 10.1479C99.5123 10.9409 99.9034 11.8996 99.9034 13.0355C99.9034 14.1779 99.5123 15.1431 98.7267 15.9296ZM93.6287 15.2764C94.2213 15.8598 94.9419 16.1523 95.8007 16.1523C96.6529 16.1523 97.3802 15.8598 97.9661 15.2764C98.557 14.693 98.8565 13.9439 98.8565 13.0355C98.8565 12.1271 98.557 11.378 97.9661 10.7946C97.3802 10.2113 96.6529 9.91877 95.8007 9.91877C94.9419 9.91877 94.2213 10.2113 93.6287 10.7946C93.0379 11.378 92.7383 12.1271 92.7383 13.0355C92.7383 13.9439 93.0379 14.693 93.6287 15.2764Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.347 16.9323V9.13876H102.595L106.476 15.2H106.521L106.476 13.7018V9.13876H107.503V16.9323H106.431L102.367 10.572H102.322L102.367 12.0768V16.9323H101.347Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4383 28.3138C88.311 28.3138 85.7562 30.6376 85.7562 33.8437C85.7562 37.0238 88.311 39.3719 91.4383 39.3719C94.5723 39.3719 97.1272 37.0238 97.1272 33.8437C97.1272 30.6376 94.5723 28.3138 91.4383 28.3138ZM91.4383 37.1944C89.7224 37.1944 88.2461 35.8116 88.2461 33.8437C88.2461 31.8498 89.7224 30.4913 91.4383 30.4913C93.1543 30.4913 94.6373 31.8498 94.6373 33.8437C94.6373 35.8116 93.1543 37.1944 91.4383 37.1944ZM79.0404 28.3138C75.9064 28.3138 73.3582 30.6376 73.3582 33.8437C73.3582 37.0238 75.9064 39.3719 79.0404 39.3719C82.1727 39.3719 84.7226 37.0238 84.7226 33.8437C84.7226 30.6376 82.1727 28.3138 79.0404 28.3138ZM79.0404 37.1944C77.3228 37.1944 75.8415 35.8116 75.8415 33.8437C75.8415 31.8498 77.3228 30.4913 79.0404 30.4913C80.7564 30.4913 82.2327 31.8498 82.2327 33.8437C82.2327 35.8116 80.7564 37.1944 79.0404 37.1944ZM64.2874 30.0087V32.3584H70.0345C69.8664 33.6714 69.417 34.6367 68.7279 35.3094C67.8891 36.1219 66.5825 37.0238 64.2874 37.0238C60.7506 37.0238 57.9811 34.2369 57.9811 30.7838C57.9811 27.3307 60.7506 24.5438 64.2874 24.5438C66.1997 24.5438 67.5912 25.2734 68.6181 26.2192L70.3141 24.5633C68.8777 23.2243 66.967 22.1957 64.2874 22.1957C59.4374 22.1957 55.3613 26.0486 55.3613 30.7838C55.3613 35.5191 59.4374 39.3719 64.2874 39.3719C66.9088 39.3719 68.8777 38.5334 70.4256 36.9604C72.0117 35.4118 72.5061 33.2343 72.5061 31.4761C72.5061 30.9301 72.4595 30.4279 72.3762 30.0087H64.2874ZM124.614 31.8303C124.147 30.5937 122.704 28.3138 119.764 28.3138C116.852 28.3138 114.427 30.5547 114.427 33.8437C114.427 36.9409 116.827 39.3719 120.044 39.3719C122.645 39.3719 124.147 37.8233 124.764 36.9214L122.833 35.6653C122.189 36.5851 121.312 37.1944 120.044 37.1944C118.784 37.1944 117.88 36.6306 117.301 35.5191L124.876 32.4592L124.614 31.8303ZM116.892 33.6714C116.827 31.5394 118.588 30.4474 119.849 30.4474C120.838 30.4474 121.677 30.9301 121.956 31.6207L116.892 33.6714ZM110.735 39.0356H113.225V22.7856H110.735V39.0356ZM106.657 29.5456H106.574C106.015 28.8988 104.948 28.3138 103.597 28.3138C100.76 28.3138 98.1674 30.7448 98.1674 33.8616C98.1674 36.9604 100.76 39.3719 103.597 39.3719C104.948 39.3719 106.015 38.7821 106.574 38.1158H106.657V38.9088C106.657 41.0229 105.501 42.1588 103.635 42.1588C102.114 42.1588 101.17 41.0863 100.78 40.1844L98.6151 41.0668C99.2392 42.5326 100.892 44.3363 103.635 44.3363C106.554 44.3363 109.017 42.6593 109.017 38.5789V28.6502H106.657V29.5456ZM103.81 37.1944C102.094 37.1944 100.657 35.7921 100.657 33.8616C100.657 31.9132 102.094 30.4913 103.81 30.4913C105.501 30.4913 106.834 31.9132 106.834 33.8616C106.834 35.7921 105.501 37.1944 103.81 37.1944ZM136.272 22.7856H130.316V39.0356H132.8V32.8784H136.272C139.029 32.8784 141.734 30.9301 141.734 27.8312C141.734 24.7339 139.023 22.7856 136.272 22.7856ZM136.337 30.6181H132.8V25.0459H136.337C138.191 25.0459 139.249 26.5491 139.249 27.8312C139.249 29.0889 138.191 30.6181 136.337 30.6181ZM151.687 28.2829C149.893 28.2829 148.027 29.0564 147.26 30.7708L149.463 31.6727C149.938 30.7708 150.81 30.4783 151.732 30.4783C153.02 30.4783 154.327 31.2339 154.347 32.5681V32.7387C153.897 32.4852 152.935 32.1098 151.752 32.1098C149.379 32.1098 146.96 33.3854 146.96 35.7661C146.96 37.9436 148.904 39.3459 151.09 39.3459C152.761 39.3459 153.683 38.6098 154.262 37.7534H154.347V39.0096H156.745V32.7761C156.745 29.8949 154.541 28.2829 151.687 28.2829ZM151.387 37.1879C150.575 37.1879 149.443 36.7947 149.443 35.8116C149.443 34.5538 150.855 34.0712 152.077 34.0712C153.17 34.0712 153.683 34.3068 154.347 34.6172C154.152 36.1219 152.825 37.1879 151.387 37.1879ZM165.483 28.6388L162.629 35.6832H162.544L159.593 28.6388H156.915L161.349 38.4831L158.819 43.9609H161.414L168.246 28.6388H165.483ZM143.099 39.0356H145.589V22.7856H143.099V39.0356Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6111 9.83591C14.22 10.2357 13.9937 10.858 13.9937 11.664V40.4135C13.9937 41.2195 14.22 41.8419 14.6111 42.2417L14.7077 42.3294L31.2083 26.2257V25.8454L14.7077 9.74166L14.6111 9.83591Z",
    fill: "url(#paint0_linear_879_10359)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7021 31.5963L31.208 26.2256V25.8454L36.7088 20.4748L36.8319 20.5446L43.3463 24.1635C45.2054 25.1905 45.2054 26.8805 43.3463 27.914L36.8319 31.5264L36.7021 31.5963Z",
    fill: "url(#paint1_linear_879_10359)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8319 31.5264L31.208 26.0356L14.6108 42.2417C15.2283 42.8754 16.2353 42.9518 17.3804 42.3181L36.8319 31.5264Z",
    fill: "url(#paint2_linear_879_10359)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8319 20.5446L17.3804 9.75303C16.2353 9.12578 15.2283 9.20215 14.6108 9.8359L31.208 26.0355L36.8319 20.5446Z",
    fill: "url(#paint3_linear_879_10359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_879_10359",
    x1: 29.7432,
    y1: 40.7129,
    x2: 7.93236,
    y2: 18.3736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_879_10359",
    x1: 45.7672,
    y1: 26.0337,
    x2: 13.549,
    y2: 26.0337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_879_10359",
    x1: 33.7738,
    y1: 23.0506,
    x2: 4.19649,
    y2: -7.24338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_879_10359",
    x1: 10.433,
    y1: 51.8065,
    x2: 23.6406,
    y2: 38.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.06eeeecdf513dfba286b8b9990c82d8f.svg";
export { ForwardRef as ReactComponent };